import React from 'react'
import { TextField, RadioField, DateOfBirthInput } from '../fields'
import { GENDER_OPTIONS } from '../constants'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const PersonalInfo = ({
  values,
  setValue,
  errors,
  genders = GENDER_OPTIONS,
}) => (
  <StepCard>
    <TitleContainer>
      <StepIndicator>1</StepIndicator>
      <SectionTitle>Personal Information</SectionTitle>
    </TitleContainer>

    <Row>
      <FieldWrapper $basis="100%">
        <TextField
          fullWidth
          label="Patient's Legal Name *"
          value={values.legal_name || ''}
          error={errors.legal_name}
          onChange={v => setValue('legal_name', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper>
        <DateOfBirthInput
          label="Date of Birth *"
          value={values.birthdate || ''}
          error={errors.birthdate}
          onChange={v => setValue('birthdate', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <RadioField
          label="Gender *"
          options={genders}
          value={values.gender || ''}
          error={errors.gender}
          onChange={v => setValue('gender', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Address 1 *"
          value={values.address_1 || ''}
          error={errors.address_1}
          onChange={v => setValue('address_1', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Address 2"
          value={values.address_2 || ''}
          error={errors.address_2}
          onChange={v => setValue('address_2', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="City/Town *"
          value={values.city || ''}
          error={errors.city}
          onChange={v => setValue('city', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="State *"
          value={values.state || ''}
          error={errors.state}
          onChange={v => setValue('state', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Zip Code *"
          value={values.zip_code || ''}
          error={errors.zip_code}
          onChange={v => setValue('zip_code', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Email *"
          value={values.email || ''}
          error={errors.email}
          onChange={v => setValue('email', v)}
        />
      </FieldWrapper>
      <FieldWrapper>
        <TextField
          fullWidth
          label="Mobile Phone *"
          value={values.phone_number || ''}
          error={errors.phone_number}
          onChange={v => setValue('phone_number', v)}
        />
      </FieldWrapper>
    </Row>

    <Row>
      <FieldWrapper $basis="100%">
        <TextField
          fullWidth
          label="How did you learn about us? *"
          value={values.referred_by || ''}
          error={errors.referred_by}
          onChange={v => setValue('referred_by', v)}
        />
      </FieldWrapper>
    </Row>
  </StepCard>
)

export default PersonalInfo
